import React from 'react';

import {MonitorFiltersFormHandler} from 'entities/monitor';
import IDomainMonitorsFilters from 'features/domain/model/DomainMonitor/IDomainMonitorsFilters';
import {dateRangeToFilters, stringToBoolean} from 'shared/lib/filterHelper';

import DomainMonitorFiltersForm, {IDomainMonitorFiltersForm} from './DomainMonitorFiltersForm/DomainMonitorFiltersForm';

interface IDomainMonitorFiltersFormHandlerProps {
    onSuccess: () => void;
    handleClose: () => void;
}

const buildFilters = ({
    sslActiveTo,
    domainActiveTo,
    active,
    sslRedirect,
    rknBlock,
    ...rest
}: Omit<IDomainMonitorFiltersForm, 'tags' | 'orderBy'>) => {
    const data: IDomainMonitorsFilters = {...rest};

    if (active !== null && active !== undefined) {
        data.active = stringToBoolean(active);
    }
    if (sslRedirect !== null && sslRedirect !== undefined) {
        data.ssl_redirect = stringToBoolean(sslRedirect);
    }
    if (rknBlock !== null && rknBlock !== undefined) {
        data.rkn_block = stringToBoolean(rknBlock);
    }

    dateRangeToFilters(sslActiveTo, data, 'ssl_active_to');
    dateRangeToFilters(domainActiveTo, data, 'domain_active_to');

    return data;
};

const DomainMonitorFiltersFormHandler: React.FC<IDomainMonitorFiltersFormHandlerProps> = (props) => (
    <MonitorFiltersFormHandler
        {...props}
        FiltersForm={DomainMonitorFiltersForm}
        buildFilters={buildFilters}
    />
);

export default DomainMonitorFiltersFormHandler;
